import React from 'react'

export function RadDivider ({ className }) {
  return (
    <hr className={className} style={{ border: 'none', borderTop: '2px solid #E9EBED', color: '#000716' }} />
  )
}
